<template>
<div>
  <div class="cover" :style="background_image ? `background-image: url(${background_image})` : ``"></div>
  <div class="container p-30 py-50">
    <img class="wythe-logo mw-100" :src="logo_image" />
    <div v-if="email_invalid" class="mb-30">
      <div class="fs-26 mb-30">Please enter a valid email to be connected to the Wythe Hotel Guest wifi.</div>
      <div class="fs-16 lh-1-4 mb-30">We will never share your address with anyone, and we will send a very limited number of notes to keep you updated on our adventures here in Brooklyn</div>
      <button @click="email_invalid = false">TRY AGAIN</button>
    </div>
    <div v-if="!has_email_registration_method" class="mb-30">
      <div class="fs-16 lh-1-4">Network registration methods are not correctly configured. Please contact an Allbridge support representative.</div>
    </div>
    <div v-if="has_email_registration_method && !email_invalid" class="mb-30">
      <div class="fs-36 mb-30">Welcome</div>
      <label class="accept-terms-label mb-20 lh-1-4">
        <input class="mr-10" type="checkbox" v-model="form.accept_terms" /> <span>I agree to the terms of service</span>
      </label>
      <div class="p-rel input-container">
        <input v-model="form.email_address" type="text" placeholder="Enter your email here*" />
        <button @click="handleClickConnect()" :disabled="disabled">SIGN IN</button>
      </div>
    </div>
    <div class="mb-30 fs-16">80 WYTHE AVE BROOKLYN, NY 11249</div>
    <div>
      <a href="https://www.instagram.com/wythehotel/" target="_blank">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="#fff" d="M16 12v-.001a4 4 0 1 0-1.172 2.829A3.843 3.843 0 0 0 16 12.06l-.001-.063V12zm2.16 0a6.135 6.135 0 1 1-1.797-4.359 5.922 5.922 0 0 1 1.798 4.256l-.001.109v-.005zm1.687-6.406v.002a1.44 1.44 0 1 1-.422-1.018c.256.251.415.601.415.988v.029-.001zm-7.84-3.44-1.195-.008q-1.086-.008-1.649 0t-1.508.047c-.585.02-1.14.078-1.683.17l.073-.01c-.425.07-.802.17-1.163.303l.043-.014a4.117 4.117 0 0 0-2.272 2.254l-.01.027a5.975 5.975 0 0 0-.284 1.083l-.005.037a11.76 11.76 0 0 0-.159 1.589l-.001.021q-.039.946-.047 1.508t0 1.649.008 1.195-.008 1.195 0 1.649.047 1.508c.02.585.078 1.14.17 1.683l-.01-.073c.07.425.17.802.303 1.163l-.014-.043a4.117 4.117 0 0 0 2.254 2.272l.027.01c.318.119.695.219 1.083.284l.037.005c.469.082 1.024.14 1.588.159l.021.001q.946.039 1.508.047t1.649 0l1.188-.024 1.195.008q1.086.008 1.649 0t1.508-.047c.585-.02 1.14-.078 1.683-.17l-.073.01c.425-.07.802-.17 1.163-.303l-.043.014a4.117 4.117 0 0 0 2.272-2.254l.01-.027c.119-.318.219-.695.284-1.083l.005-.037c.082-.469.14-1.024.159-1.588l.001-.021q.039-.946.047-1.508t0-1.649-.008-1.195.008-1.195 0-1.649-.047-1.508c-.02-.585-.078-1.14-.17-1.683l.01.073a6.254 6.254 0 0 0-.303-1.163l.014.043a4.117 4.117 0 0 0-2.254-2.272l-.027-.01a5.975 5.975 0 0 0-1.083-.284l-.037-.005a11.76 11.76 0 0 0-1.588-.159l-.021-.001q-.946-.039-1.508-.047t-1.649 0zM24 12q0 3.578-.08 4.953a6.64 6.64 0 0 1-6.985 6.968l.016.001q-1.375.08-4.953.08t-4.953-.08a6.64 6.64 0 0 1-6.968-6.985l-.001.016q-.08-1.375-.08-4.953t.08-4.953A6.64 6.64 0 0 1 7.061.079L7.045.078q1.375-.08 4.953-.08t4.953.08a6.64 6.64 0 0 1 6.968 6.985l.001-.016Q24 8.421 24 12z"/>
        </svg>
      </a>
    </div>
  </div>
</div>
</template>

<script>
// import TermsOfService from '@/utilities/TermsOfService'

export default {
  name: 'custom_template_wythe',
  props: [ 'template', 'portal', 'connection_data' ],
  // components: { TermsOfService },
  data(){
    return{
      logo_image: `https://sky-production.s3.amazonaws.com/brandportalimages/wythelogo.png`,
      background_image: `https://sky-production.s3.amazonaws.com/brandportalimages/wythebg.webp`,
      disabled: true,
      // eslint-disable-next-line
      is_email: new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,"gi"),
      email_invalid: false,
      form: {
        accept_terms: false,
        email_address: null,
      },
    }
  },
  computed: {
    has_email_registration_method: function(){
      return this.portal.registration_methods.findIndex(registration_method => registration_method.registration_method_id === 3) !== -1;
    }
  },
  watch: {
    'form': {
      deep: true,
      handler(){ this.disabled = !this.form.accept_terms }
    }
  },
  created(){
    document.documentElement.classList.add('wythe');
  },
  methods: {
    emailIsValid:function(){
      return new Promise(resolve => {
        return resolve(this.is_email.test(this.form.email_address));
      })
    },
    handleClickConnect: async function(){
      this.email_invalid = false;

      const is_email_valid = await this.emailIsValid();
      if(!is_email_valid){
        this.email_invalid = true;
        return;
      }

      if(!this.form.accept_terms) return;

      if(this.disabled) return;
      this.disabled = true;
      const method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 3);
      const rateplan = method.rate_plans[0];
      const include_email = !!this.form.email_address && !!this.form.email_address.trim();
      const data = {
        registration_method_id: method.registration_method_id,
        rateplan_id: rateplan.rateplan_id,
        ...(include_email && { email_address: this.form.email_address }),
        ...(include_email && { email_opt_in: 1 }),
      }
      this.$emit('emitRegistrationMethodData', data);
    },
  }
}
</script>
<style>

@font-face { font-family: 'Gestura'; src: url('https://sky-production.s3.amazonaws.com/brandportalimages/GesturaDisplay-Extralight.woff') format('woff'); }
@font-face { font-family: 'ReworkMicro'; src: url('https://sky-production.s3.amazonaws.com/brandportalimages/ReworkMicro-Light.woff') format('woff'); }

.wythe-logo { width: 350px; margin: 0 auto 30px auto; }
.wythe .cover { opacity: 1; position: fixed; z-index: 0; top: 0; left: 0; right: 0; bottom: 0; width: 100%; background-size: cover; background-position: center; }
.wythe .accept-terms-label { font-family: 'ReworkMicro'; display: flex; align-items: center; cursor: pointer; }
.wythe .accept-terms-label input { flex-grow: 0; }
.wythe .container {  background: unset; border-radius: unset; max-width: 565px; color: #fff; }
.wythe #app, .wythe input, .wythe button { font-family: 'Gestura', serif;  }
.wythe a { color: #fff; text-decoration: underline; }
.wythe .input-container { display: flex; align-items: center; }
.wythe input[type=text] { font-family: 'ReworkMicro'; font-size: 16px; flex-grow: 1; margin-right: 10px; outline: none; color: #000; padding: 10px; line-height: 1; border: 0; width: 100%; }
.wythe button { font-family: 'ReworkMicro'; flex-grow: 0; white-space: nowrap; background: rgba(255,255,255,1); padding: 10px 30px; font-weight: bold; border: 0; cursor: pointer; }

@media screen and (max-width: 600px) {
  .wythe .input-container { flex-direction: column; }
  .wythe input[type=text] { margin: 0 0 10px 0; }
  .wythe button { width: 100%; }

}

</style>
